import HeroImage from "../components/HeroImage";
import DrawerAppbar from "../components/DrawerAppbar";
import ImageStack from "../components/ImageStack";
import adventure from "../assets/adventure/adventure.jpeg";
import adventure2 from "../assets/adventure/borond.jpg";
import adventure3 from "../assets/adventure/adventure3.jpeg";
import Footer from "../components/Footer";
import {useTranslation} from "react-i18next";

const TravelSelector = () => {
    const {t} = useTranslation()
    const cards = [
        {
            image: adventure2,
            title: t('adventure.cesys'),
            link: 'https://utazas.jettravel.hu/',
            description: t('adventure.cesysDescription')
        },
        {
            image: adventure3,
            title: t('adventure.adventure'),
            link: '/adventures',
            description: t('adventure.adventureDescription')
        },
    ]
    return <DrawerAppbar fade>
        <HeroImage darken={0.4} title={t('travelWithUs.title')} underlineColor='#ff0000' image={adventure}/>
        <div style={{ marginBottom: '64px'}}>

            <ImageStack images={cards}/>
        </div>
        <Footer />
    </DrawerAppbar>
}

export default TravelSelector